import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-jquitabs',
	templateUrl:'./JQUITabsPage.html',
	styles: [],
	styleUrls:['./JQUITabsPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class JQUITabsPage
{
	mdContent_228 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.tabs.JQUITabs;
\`\`\``;
	mdContent_229 = `\`\`\`java
new JQUITabs&lt;&gt;()
\`\`\``;
	mdContent_230 = `\`\`\`java
var tabs = new JQUITabs<>();
tabs.addTab("Tab 1", new Div<>().setText("Content 1"));
tabs.addTab("Tab 2", new Div<>().setText("Content 2"));
\`\`\``;
}
